export const helpDeskApiUrls = {
  GetConnectionRequests: "helpDesk/GetConnectionRequests",
  GetHelpRequests: "helpDesk/GetHelpRequests",
  UpdateIsResolved: "helpDesk/UpdateIsResolved",
};

export default class HelpDeskAPI {
  constructor(httpsClient, cache) {
    this.httpsClient = httpsClient;
    this.cache = cache;
  }

  async getConnectionRequests(data, token) {
    return this.get(helpDeskApiUrls.GetConnectionRequests, data, token);
  }

  async getHelpRequests(data, token) {
    return this.get(helpDeskApiUrls.GetHelpRequests, data, token);
  }

  async updateIsResolved(data, token) {
    return this.get(helpDeskApiUrls.UpdateIsResolved, data, token);
  }

  async get(url, data, token, eAlert, sAlert) {
    return await this.httpsClient.get(url, data, token, eAlert, sAlert);
  }

  async post(url, data, token, eAlert, sAlert) {
    this.cache.remove("tests");

    return await this.httpsClient.post(url, data, token, eAlert, sAlert);
  }
}
